module.exports = __webpack_public_path__ + "img/GAME_PIANO2.be831748.jpg";